import { Box } from "@mui/material"
import { Icon } from "assets/Icons_";
import { ETStyledButton } from "components/Button/EusButton";
import Dropdown from "components/mui/Dropdown"
import DropdownItem from "components/mui/DropdownItem";
import { BREAK_ } from "constants";
import { useBreak } from "hooks/useBreak";
import { useRef } from "react";
import { getFocus, useAtom, useGet, useSet } from "state/jotai";
import { getIsoData, getSeasonIsoData, setSeasonIsoData } from "state/jotai.isometryDataHooks";
import { active_project, iconRotate, mobileShiftSeasonMenu } from "state/store.global";
import { _project } from "state/store.projects";
import { _seasons_isometry } from "state/store.season";
import styled from "styled-components";

export const SelectWeatherMobile = () => {
    const dropdownRef         = useRef(null);
    const isDesktop           = useBreak("md_up");
    const { pin, pid }        = useGet(active_project);
    const activeIsometryFrame = getIsoData("activeframe");
    const buttonsLabel        = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

    const [iconRotated, setIconRotated] = useAtom(iconRotate)

    const season     = getFocus(_seasons_isometry, 'season_type');
    const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;

    const setShiftSeasonMenu = useSet(mobileShiftSeasonMenu);

    const weather     = getSeasonIsoData("season_type");
    const setWeather  = setSeasonIsoData("season_type");
    const weatherType = weather?.[activeIsometryFrame]?.type;

    const handleWeatherSelect = (w) => {
        setWeather({...weather, [activeIsometryFrame]: {type: w}});
    };


    return <Select>
        <Box>
        {/* <Box
                sx={{
                  color         : "#fff",
                  borderBottom  : `1px solid ${clr.primary_text}`,
                  display       : "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display       : "flex",
                    flexDirection : "column",
                    justifyContent: "center",
                    width         : "100%",
                    padding       : "16px 16px 16px 48px ",
                  }}
                >
                  <Box
                    sx={{
                      display       : "flex",
                      justifyContent: "center",
                      color         : clr?.primary_text,
                    }}
                  >
                    <span className = "h5">
                        Vælg årstid: 
                    </span>
                  </Box>
                </Box>
                <Box
                  sx      = {{ padding: "16px" }}
                  onClick = {() => {
                    setShiftSeasonMenu(false)
                  }}
                >
                  <span className = "icon-hover-effect">
                    <Icon
                      icon     = {"close"}
                      size     = "xl"
                      isFaIcon = {true}
                      color    = {clr?.primary_text}
                    />
                  </span>
                </Box>
              </Box> */}
              <Box sx={{ padding: "16px 44.5px", display: 'flex', flexDirection: 'row', gap: '16px' }}>
                {options.map((option, i) => (
                    <ETStyledButton
                    padding  = {"0"}
                    borderRadius={'50%'}
                    width = {'48px'}
                    height = {'48px'}
                    variant  = {"secondary"}
                    isMobile = {true}
                    pin      = {pin}
                    clr      = {clr}
                    hideBoxShadow = {true}
                    hiderBorder = {true}
                    backgroundColor={weatherType?.toLowerCase()  === option.Label ? clr.primary : `${clr.primary}bf`}
                    // border={weatherType?.toLowerCase()  === option.Label ? '2px solid #D1D1D1' : '2px solid #fff'}
                    onClick  = {()=> {
                    setIconRotated(!iconRotated)
                    handleWeatherSelect(option.Label)
                    }}
                    >
                        <Icon icon      = {option.icon_name} size = { 24 } color = {"#fff"}/>
                        {/* <div  className = "eus-button-2">{ buttonsLabel?.filter( btn => btn.UILabelProperty === option.id)[0]?.Label }</div> */}
                    </ETStyledButton>
                ))}
              </Box>
        </Box>
    </Select>
}


export const Select = styled.div`
  display         : flex;
  align-items     : center;
  justify-content : center;
  cursor          : pointer;
  font-size       : 1.125rem;
  gap             : 8px;
  position        : absolute;
  // bottom          : 66px;
  left            : 50%;
  top             : 68px;
  transform: translateX(-50%);
  // background-color: ${({  }) => `${clr.primary}e6`};
  border-radius: 6px;
  z-index: 10;
`


const options = [
    {
        icon_name: "spring",
        Label    : "spring",
        id       : "Forar"
    },
    {
        icon_name: "sun",
        Label    : "summer",
        id       : "Sommer"
    },
    {
        icon_name: "cloud",
        Label    : "fall",
        id       : "Efterar"
    },
    {
        icon_name: "winter",
        Label    : "winter",
        id       : "Vinter"
    }
]